import React, { Component } from 'react';
import {
    CardHeader,
    Card,
    CardContent,
    Avatar,
    Grid,
    RadioGroup,
    Radio,
    FormControlLabel,
    Typography,
    Checkbox,
    Tooltip,
} from '@mui/material';
import './form.scss';
import { Divider } from 'rsuite';
import { withTranslation } from 'react-i18next';
import NumberInput from '../../../common/components/UI/Input/Number';
import ActionButtons from '../../../common/components/UI/ActionButtons/ActionButtons';
import CustomButton from '../../../common/components/UI/Button/Button';
import ReactDatePicker from '../../../common/components/UI/Datepicker/Datepicker';
import MultiSingleDayPicker from '../../../common/components/UI/Datepicker/MultiSingleDayPicker/MultiSingleDayPicker';
import { handleChangeDualBox, moveAll } from '../../../common/components/handlerFunctions';
import Dualbox from '../../../common/components/UI/DualListBox/DualListBox';
import { LocationsPicker } from '../../../common-client2/src/components';
import HyperfindConfigs from './dynamicHyperfindConfigs'
import moment from 'moment';
import { getParsedLocations } from '../services/location.service';
import _ from 'lodash'

import { VTO_TYPES, WARNING_TYPES } from '../../constants';
import {
    RequestTypes, VoluntaryTimeOffType, RequestSubtypes, TypeOfPeriod, ManagerCreateRequestsActionNames
} from '../../Enums';
import { formatDateRange, getAsLongDate, getAsLongDateTime, formatAs, DateFnsFormats, applyUkgUserTimeZoneTransformation } from '../../../common-client2/src/services/ukgDateTime';
import { findItem, generateInputs } from './settings.service';
import HyperfindRatio from './HyperfindRatio';
import SettingInformationStep from './Step1-Information';
import OpenShiftPicker from '../../../common/components/OpenShiftPicker/OpenShiftPicker';
import generateReactKey from '../../../services/generateReactKey';
import { createCopyName } from '../../auxilaries';
import RequestPeriodLimits from '../../App/components/RequestPeriodLimits';
import {
    getOpenShiftOptions,
    initialState,
    requestTypeList,
    transformHyperfindSettingsToModel,
} from "./form.service";
import './form.scss';
import { MomentFormats } from '../../utils';
import HelpIcon from "@mui/icons-material/Help";

const MSF_CLASSES = {
    NOOVERFLOW: 'msf-no-overflow',
    formContainer: 'msf-form-container',
    formContainerReadOnly: 'msf-form-container-readonly',
    cards: 'msf-cards',
    cardHeader: 'msf-card-header',
    avatar: 'msf-avatar',
    maxLength: 'msf-max-length',
    periodsGrid: 'msf-periods-grid',
    periodLabel: 'msf-period-label',
    periodPicker: 'msf-period-picker',
};

class Form extends Component {
    constructor(props) {
        super(props);
        const convertedToday = applyUkgUserTimeZoneTransformation(new Date());
        this.state = {
            ...initialState,
            prevState: initialState,
            todayDateUserFormat: getAsLongDate(convertedToday),
            todayDateYMD: formatAs(convertedToday, DateFnsFormats.YMD)
        };
    }

    componentDidMount = async () => {
        const { settingSelected, action, hyperFindList, workruleList, timePeriodRatioOptions, managerList, t, settingList } = this.props;
        const { vtoTypes, todayDateYMD, todayDateUserFormat } = this.state;

        let locations = {};

        let hfList = hyperFindList.map(hyperfind => {
            return {
                ...hyperfind,
                ratioValue: 0,
                ratioPercentageValue: 0,
            }
        })

        let newTimePeriodRatioOptions = timePeriodRatioOptions.map(option => {
            return {
                ...option,
                value: option.id,
                label: t(`form.coverageOptions.${option.name}`),
            }
        });

        const isEdit = action === ManagerCreateRequestsActionNames.Edit;
        const isDuplicate = action === ManagerCreateRequestsActionNames.Duplicate;
        const isView = action === ManagerCreateRequestsActionNames.View;

        if (isEdit || isDuplicate || isView) {
            let name = ''
            let editable = false
            if (isEdit) {
                name = settingSelected.name;
                editable = settingSelected.isFullyEditable
            } else if (isDuplicate) {
                name = createCopyName(
                    settingSelected.name,
                    managerList.map(x => x.name),
                    t('common2:copyOf'));
                editable = true
            } else if (isView) {
                name = settingSelected.name;
            }

            if (settingSelected.type === RequestTypes.openShift || settingSelected.type === RequestTypes.voluntaryTimeOff) {
                let effectDate
                if (settingSelected.requestPeriod_TypeOfPeriod === 1) {
                    effectDate = todayDateYMD
                } else {
                    effectDate = formatAs(settingSelected.requestPeriod_StartDate, DateFnsFormats.YMD);
                }
                locations = await getParsedLocations(effectDate);
            }

            let selectedHF = []
            const maxAwarding = settingSelected.awardingDistribution.reduce((a, b) => { return a + b.value }, 0)
            for (const distribution of settingSelected.awardingDistribution) {                
                const updatedDistribution = {
                    ...hfList.find(hf => hf.value === distribution.hyperfindId),
                    ratioValue: distribution.value,
                    ratioPercentageValue: (distribution.value / maxAwarding) * 100,
                }
                selectedHF.push(updatedDistribution)
                hfList = hfList.map(hf => hf.value === distribution.hyperfindId ?
                    updatedDistribution : hf
                )
            }

            // VTO Options
            let selectedVTOType;
            let newVtoTypes = VTO_TYPES.map((type) => {
                if (type.value === settingSelected.voluntaryTimeOffType) {
                    selectedVTOType = { ...type, checked: true };
                    return selectedVTOType;
                }
                return type
            })
            let selectedTimePeriodOption = newTimePeriodRatioOptions.find(option => option.id === settingSelected.timePeriodRatioOption)
            const isAnyTimeSubmission = settingSelected.toCoverPeriod_TypeOfPeriod === TypeOfPeriod.Forever;
            const isAnyTimeRequest = settingSelected.requestPeriod_TypeOfPeriod === TypeOfPeriod.Forever;

            let requestPeriodSelected = {
                startDate: moment(settingSelected.requestPeriod_StartDate),
                endDate: moment(settingSelected.requestPeriod_EndDate),
                label: formatDateRange(settingSelected.requestPeriod_StartDate, settingSelected.requestPeriod_EndDate, getAsLongDate),
                forever: isAnyTimeRequest,
                singleLabel: formatAs(settingSelected.requestPeriod_StartDate, DateFnsFormats.YMD)
            };

            const coverPeriodSelected = {
                startDate: moment(settingSelected.toCoverPeriod_StartDate),
                endDate: moment(settingSelected.toCoverPeriod_EndDate),
                label: formatDateRange(settingSelected.toCoverPeriod_StartDate, settingSelected.toCoverPeriod_EndDate, getAsLongDateTime),
                forever: isAnyTimeSubmission,
            };

            let multiSingleDates = [];
            if (selectedVTOType && selectedVTOType.value === VoluntaryTimeOffType.TimePeriod) {
                requestPeriodSelected = {
                    ...requestPeriodSelected,
                    label: formatDateRange(settingSelected.requestPeriod_StartDate, settingSelected.requestPeriod_EndDate, getAsLongDateTime),
                }
            }
            else if (selectedVTOType.value === VoluntaryTimeOffType.SingleDay) {
                multiSingleDates = [requestPeriodSelected.startDate];
            }

            const hyperfindSettings = settingSelected.hyperfindSettings.map(transformHyperfindSettingsToModel(isDuplicate, settingList));

            /**
             * Common state props between `this.state` and `this.state.prevState`
             */
            const commonStateProps = {
                name: name,
                description: settingSelected.description,
                details: settingSelected.details,
                requestType: findItem(requestTypeList, settingSelected.type, 'value'),
                autoApproval: settingSelected.autoApproval,
                hyperfindSettings,
                requestPeriodSelected,
                coverPeriodSelected,
                isBlockDays: settingSelected.VoluntaryTimeOffType === VoluntaryTimeOffType.BlockOfDays,
                workrules: {
                    excluded: workruleList.filter(rule => settingSelected.openShiftWorkRules.includes(rule.workRuleId)),
                    included: workruleList.filter(rule => !settingSelected.openShiftWorkRules.includes(rule.workRuleId)),
                },
                locationEffectiveDate: settingSelected.requestPeriod_TypeOfPeriod === TypeOfPeriod.Range ? getAsLongDate(settingSelected.requestPeriod_StartDate) : todayDateUserFormat,
                isFullyEditable: editable,
                vtoTypes: newVtoTypes,
                selectedTimePeriodRatioOption: selectedTimePeriodOption,
                multiSingleDates: multiSingleDates,
                selectedOpenShifts: settingSelected.selectedOpenShifts,
                isAllOpenShiftEnabled: settingSelected.isAllOpenShiftEnabled,
                isRequestPeriodLimitsEnabled: isAnyTimeSubmission && isAnyTimeRequest && !!settingSelected.requestPeriodLimitInDays,
                requestPeriodLimitInDays: settingSelected.requestPeriodLimitInDays,
                requestLocations: settingSelected.requestLocations,
                maximumVtoCount: settingSelected.maximumVtoCount,
            };

            const stateFromSetting = {
                ...commonStateProps,
                hyperFindList: hfList,
                locationNodes: locations,
                selectedHyperfindRatios: selectedHF,
                isSubmitable: action === ManagerCreateRequestsActionNames.Duplicate,
                timePeriodRatioOptions: newTimePeriodRatioOptions,
            }

            const prevState = isDuplicate
                ? _.cloneDeep(initialState)
                : _.cloneDeep(stateFromSetting);

            this.setState({
                ...stateFromSetting,
                prevState,
            });
        }
        else {
            let newVtoTypes = vtoTypes.map((type, i) => {
                if (i === 0) {
                    return { ...type, checked: true }
                }
                return type;
            });

            this.setState({
                vtoTypes: newVtoTypes,
                timePeriodRatioOptions: newTimePeriodRatioOptions,
                hyperFindList: hfList,
                workrules: {
                    excluded: [{ "label": t('form.noneWithoutWorkRule'), "value": -1, "workRuleId": -1, "target": "workrules" }],
                    included: workruleList.filter(rule => rule.workRuleId !== -1),
                },
                isFullyEditable: true
            })
        }
    }

    isShowRequestPeriodLimits = () => {
        const {
            coverPeriodSelected: submissionPeriod,
            requestPeriodSelected: requestPeriod,
            requestType: { value: requestType },
        } = this.state;

        const eligibleRequestTypes = [
            RequestTypes.toCover,
            RequestTypes.shiftSwap,
        ];

        const isRequestTypeEligible = eligibleRequestTypes.includes(requestType);
        const isAnyTimeSubmission = submissionPeriod.forever;
        const isAnyTimeRequest = requestPeriod.forever;

        return (
            isRequestTypeEligible &&
            isAnyTimeSubmission &&
            isAnyTimeRequest
        );
    };

    componentDidUpdate(_, prevState) {
        const {
            workrules: { included: selectedWorkRules },
            requestLocations,
            requestPeriodSelected: requestPeriod,
        } = this.state;

        const {
            workrules: { included: oldSelectedWorkRules },
            requestLocations: oldRequestLocations,
            requestPeriodSelected: oldRequestPeriod,
        } = prevState;

        const dateRangePickers = document.getElementsByClassName('daterangepicker');

        const hideDateRangePicker = (/** @type {number} */index) => dateRangePickers[index].getElementsByClassName("ranges")[0].style.display = "none";

        if (dateRangePickers[0]) {
            hideDateRangePicker(0);
        }

        if (dateRangePickers[1]) {
            hideDateRangePicker(1);
        }

        const isChangedWorkRules = JSON.stringify(selectedWorkRules) !== JSON.stringify(oldSelectedWorkRules);
        const isChangedRequestLocations = JSON.stringify(requestLocations) !== JSON.stringify(oldRequestLocations);
        const isChangedRequestPeriod = JSON.stringify(requestPeriod) !== JSON.stringify(oldRequestPeriod);

        const isFetchSelectOpenShiftData = (
            (isChangedWorkRules || isChangedRequestLocations || isChangedRequestPeriod) &&
            this.isOpenShiftOptionsEnabled()
        );

        if (isFetchSelectOpenShiftData) {
            this.fetchSelectOpenShiftData();
        }
    }

    handleChangeTextfield = (target, value) => {
        this.setState({ [target]: value }, () => this.submitableForm())
    }

    submitForm = () => {
        const { description, details, name, requestType, requestPeriodSelected, coverPeriodSelected, hyperfindSettings,
            workrules, selectedHyperfindRatios, vtoTypes, selectedTimePeriodRatioOption, isSubmitable, requestLocations, multiSingleDates,
            selectedOpenShifts, isAllOpenShiftEnabled, requestPeriodLimitInDays, isRequestPeriodLimitsEnabled, maximumVtoCount,
        } = this.state;

        const { action, settingSelected } = this.props;
        if (isSubmitable) {
            let newForm = {}
            let requestPeriod = {
                StartDate: requestPeriodSelected.startDate.format(MomentFormats.ISO),
                EndDate: requestPeriodSelected.endDate.format(MomentFormats.ISO),
                TypeOfPeriod: requestPeriodSelected.forever ? 1 : 0
            }
            let vtoType, timePeriodRatioOption;

            if (requestType.value === RequestTypes.voluntaryTimeOff) {
                vtoType = vtoTypes.find(type => type.checked).value
                if (vtoType && vtoType === VoluntaryTimeOffType.TimePeriod) {
                    timePeriodRatioOption = selectedTimePeriodRatioOption.id
                }
            }

            const periodLimitInDays = !isRequestPeriodLimitsEnabled ? null : requestPeriodLimitInDays;

            switch (action) {
                case ManagerCreateRequestsActionNames.Create:
                case ManagerCreateRequestsActionNames.Duplicate:
                    const isMultiSingleDays = multiSingleDates.length >= 2;
                    newForm = {
                        name,
                        description,
                        details,
                        type: requestType.value,
                        toCoverPeriod: {
                            StartDate: coverPeriodSelected.startDate.format(MomentFormats.ISO),
                            EndDate: coverPeriodSelected.endDate.format(MomentFormats.ISO),
                            TypeOfPeriod: coverPeriodSelected.forever ? 1 : 0
                        },
                        requestPeriod: requestPeriod,
                        isMultiSingleDayVto: isMultiSingleDays,
                        multiSingleDays: multiSingleDates.map(x => x.format(MomentFormats.ISO)),
                        openShiftWorkrules: workrules.excluded.map(rule => rule.workRuleId),
                        requestLocations: requestLocations,
                        selectedOpenShifts: selectedOpenShifts,
                        isAllOpenShiftEnabled: isAllOpenShiftEnabled,
                        requestPeriodLimitInDays: periodLimitInDays,
                        awardingDistribution: selectedHyperfindRatios.map(hyperfind => {
                            return {
                                hyperfindId: hyperfind.value,
                                value: hyperfind.ratioValue,
                                hyperfindName: hyperfind.label,
                            }
                        }),
                        maximumVtoCount,
                        hyperfindAdminSettings: hyperfindSettings.map(config => {
                            return {
                                hyperfindId: config.hyperfindId,
                                adminSettingId: config.adminSettingsId,
                                enablePartialShifts: config.enablePartialShifts,
                            }
                        }),
                        voluntaryTimeOffType: vtoType,
                        timePeriodRatioOption: timePeriodRatioOption,
                    }
                    break
                case 'Edit':
                    newForm = {
                        aggregateRootId: settingSelected.aggregateRootId,
                        name,
                        description,
                        details,
                        managerRequestType: requestType.value,
                        toCoverPeriod: {
                            StartDate: coverPeriodSelected.startDate.format(MomentFormats.ISO),
                            EndDate: coverPeriodSelected.endDate.format(MomentFormats.ISO),
                            TypeOfPeriod: coverPeriodSelected.forever ? 1 : 0
                        },
                        requestPeriod: requestPeriod,
                        openShiftWorkrules: workrules.excluded.map(rule => rule.workRuleId),
                        requestLocations: requestLocations,
                        selectedOpenShifts: selectedOpenShifts,
                        isAllOpenShiftEnabled: isAllOpenShiftEnabled,
                        requestPeriodLimitInDays: periodLimitInDays,
                        awardingDistribution: selectedHyperfindRatios.map(hyperfind => {
                            return {
                                hyperfindId: hyperfind.value,
                                value: hyperfind.ratioValue,
                                hyperfindName: hyperfind.label,
                            }
                        }),
                        maximumVtoCount,
                        hyperFindInfos: !settingSelected?.hyperfindSettings?.some(x => x.warnings?.includes(WARNING_TYPES.FAILING_HYPERFIND_EXECUTION))
                            ? (
                                [...settingSelected.hyperfindSettings.map(setting => {
                                    let config = hyperfindSettings.find(config => config.hyperfindId === setting.hyperfindId && config.adminSettingsId === setting.adminSettingsId)
                                    //If its the same as the original then keep, otherwise delete it
                                    if (config) {
                                        return {
                                            ...config,
                                            managerEntityId: setting.managerEntityId,
                                            markedForDeletion: false,
                                            isNew: false
                                        }
                                    } else {
                                        return {
                                            ...setting,
                                            markedForDeletion: true,
                                            isNew: false
                                        }
                                    }   
                                }),
                                ...hyperfindSettings.filter(config => !settingSelected.hyperfindSettings.find(setting => setting.hyperfindId === config.hyperfindId && setting.adminSettingsId === config.adminSettingsId))
                                                    .map(config => {
                                                            return {
                                                                ...config,
                                                                adminSettingId: config.adminSettingsId,
                                                                isNew: true,
                                                                markedForDeletion: false,
                                                            }
                                                        })])
                            : ( 
                                [...settingSelected.hyperfindSettings.map(setting =>  { 
                                    let config = hyperfindSettings.find(config => config.managerEntityId === setting.managerEntityId)
                                    return {
                                        ...config,
                                        markedForDeletion: false,
                                        isNew: false
                                    }
                                })]),
                        voluntaryTimeOffType: vtoType,
                        timePeriodRatioOption: timePeriodRatioOption,
                    }
                    break
                default:
                    return
            }
            this.props.handleSubmitForm(newForm);
        }
    }

    handleChange = (target, value) => {
        this.setState({ [target]: value }, () => this.submitableForm())
    }

    /**
     * @param {{ label: string, value: number }} value
     */
    handleChangeRequestType = (value) => {
        const { todayDateYMD } = this.state;
        const now = formatAs(applyUkgUserTimeZoneTransformation(new Date()), DateFnsFormats.ISO);

        this.setState(() => ({
            requestType: value,
            hyperfindSettings: [],
            requestPeriodSelected: {
                startDate: moment(todayDateYMD),
                endDate: moment(todayDateYMD),
                label: '',
                singleLabel: '',
                forever: false,
            },
            coverPeriodSelected: {
                startDate: moment(now),
                endDate: moment(now),
                label: '',
                forever: false,
            },
            locationEffectiveDate: null
        }), () => this.submitableForm());
    }

    isNameAvailable = (_, value) => {
        const { managerList, settingSelected, action } = this.props;

        const usedManagerSettingNames = managerList.filter(x => {
            if (action === ManagerCreateRequestsActionNames.Duplicate && settingSelected.aggregateRootId === x.aggregateRootId) {
                // It is the original manager setting that is getting duplicated, add to list of used names
                return true;
            }
            return x.aggregateRootId !== settingSelected.aggregateRootId;
        }).map(x => x.name);
        return !usedManagerSettingNames.includes(value);
    }

    isDirtyForm = () => {
        const {
            isAllOpenShiftEnabled, multiSingleDates, isRequestPeriodLimitsEnabled, requestPeriodLimitInDays,
            name, description, details, hyperfindSettings, requestType, requestPeriodSelected, coverPeriodSelected, workrules, selectedHyperfindRatios,
            prevState, isBlockDays, selectedTimePeriodRatioOption, vtoTypes, locationEffectiveDate, requestLocations, selectedOpenShifts, maximumVtoCount,
        } = this.state;

        const isStep1Dirty = (
            name !== prevState.name ||
            description !== prevState.description ||
            details !== prevState.details
        );

        const isStep2Dirty = !_.isEqual(requestType, prevState.requestType);

        const isStep3Dirty = (
            // TODO D. 2023-03-28 (not important rn) - Find the other check in the same step for the other setting
            (!_.isEqual(hyperfindSettings, prevState.hyperfindSettings))
        );

        const isStep4Dirty = (
            requestPeriodSelected.forever !== prevState.requestPeriodSelected.forever ||
            coverPeriodSelected.forever !== prevState.coverPeriodSelected.forever ||
            (
                requestPeriodSelected.startDate.format(MomentFormats.ISO) !== prevState.requestPeriodSelected.startDate.format(MomentFormats.ISO) ||
                requestPeriodSelected.endDate.format(MomentFormats.ISO) !== prevState.requestPeriodSelected.endDate.format(MomentFormats.ISO)
            ) ||
            (
                coverPeriodSelected.startDate.format(MomentFormats.ISO) !== prevState.coverPeriodSelected.startDate.format(MomentFormats.ISO) ||
                coverPeriodSelected.endDate.format(MomentFormats.ISO) !== prevState.coverPeriodSelected.endDate.format(MomentFormats.ISO)
            ) ||
            requestPeriodLimitInDays !== prevState.requestPeriodLimitInDays ||
            isRequestPeriodLimitsEnabled !== prevState.isRequestPeriodLimitsEnabled
        );

        // For when it's OS or VTO
        const isStep5Dirty = (
            isAllOpenShiftEnabled !== prevState.isAllOpenShiftEnabled ||
            locationEffectiveDate !== prevState.locationEffectiveDate ||
            isBlockDays !== prevState.isBlockDays ||
            !_.isEqual(multiSingleDates, prevState.multiSingleDates) ||
            !_.isEqual(selectedTimePeriodRatioOption, prevState.selectedTimePeriodRatioOption) ||
            !_.isEqual(selectedHyperfindRatios, prevState.selectedHyperfindRatios) ||
            !_.isEqual(workrules, prevState.workrules) ||
            !_.isEqual(requestLocations, prevState.requestLocations) ||
            !_.isEqual(selectedOpenShifts, prevState.selectedOpenShifts) ||
            !_.isEqual(vtoTypes, prevState.vtoTypes) ||
            !_.isEqual(maximumVtoCount, prevState.maximumVtoCount)
        );

        return (isStep1Dirty || isStep2Dirty || isStep3Dirty || isStep4Dirty || isStep5Dirty);
    }

    submitableForm = () => {
        const {
            isAllOpenShiftEnabled, step1Errors, hyperfindRatioErrors, isRequestPeriodLimitsEnabled, requestPeriodLimitInDays,
            name, hyperfindSettings, requestType, requestPeriodSelected, coverPeriodSelected, workrules, selectedHyperfindRatios,
            selectedTimePeriodRatioOption, vtoTypes, requestLocations, selectedOpenShifts, maximumVtoCount,
        } = this.state;

        const { settingList, hyperFindList } = this.props;
        let isOpenShiftSignUp = false;
        let isInvalid = step1Errors;
        let isValidRequestLimit = true;

        // Check if all current hyperfind IDs exist in the available options
        const hasInvalidHyperfinds = hyperfindSettings.some(config => {
            return !hyperFindList.some(option => option.value === config.hyperfindId);
        });

        switch (requestType.value) {
            case RequestTypes.toCover:
            case RequestTypes.shiftSwap:
                if (hyperfindSettings?.length) {
                    const adminSetting = settingList.find(setting => hyperfindSettings[0].adminSettingsId === setting.id);

                    if (isRequestPeriodLimitsEnabled) {
                        isValidRequestLimit = adminSetting && Number.isInteger(requestPeriodLimitInDays);
                    }
                }

                isInvalid = isInvalid 
                    || name.trim() === '' 
                    || hyperfindSettings.length === 0 
                    || hyperfindSettings.find(config => config.hyperfindId === undefined || config.adminSettingsId === undefined)
                    || (!coverPeriodSelected.forever && coverPeriodSelected.label.trim() === '') 
                    || (!requestPeriodSelected.forever && requestPeriodSelected.label.trim() === '') 
                    || !isValidRequestLimit
                    || hasInvalidHyperfinds

                let manualOrAutomaticProcess;
                let isKeepEmployeeWorkRule;
                let isAllowMultipleRequests;
                let usedHyperfinds = [];
                for (let i = 0; i < hyperfindSettings.length; i++) {
                    let adminSetting = settingList.find(x => x.id === hyperfindSettings[i].adminSettingsId);
                    if (adminSetting) {
                        if (i === 0) {
                            manualOrAutomaticProcess = adminSetting.autoApproval;
                            isKeepEmployeeWorkRule = adminSetting.isKeepEmployeeWorkRule;
                            isAllowMultipleRequests = adminSetting.isAllowMultipleRequests;
                        } else {
                            if (adminSetting.autoApproval !== manualOrAutomaticProcess ||
                                (requestType.value === RequestTypes.shiftSwap && (adminSetting.isKeepEmployeeWorkRule !== isKeepEmployeeWorkRule || adminSetting.isAllowMultipleRequests !== isAllowMultipleRequests))) {
                                isInvalid = true;
                            }
                        }
                    } 
                    else {
                        isInvalid = true;
                    }
                    if (usedHyperfinds.includes(hyperfindSettings[i].hyperfindId)) {
                        isInvalid = true;
                        break;
                    } else {
                        usedHyperfinds.push(hyperfindSettings[i].hyperfindId);
                    }
                }
                break;
            case RequestTypes.openShift:
                if (hyperfindSettings.length) {
                    let adminSetting = settingList.find(setting => hyperfindSettings[0].adminSettingsId === setting.id);
                    const isFillOpenShift = adminSetting?.requestSubtype === RequestSubtypes.fill;

                    if (isFillOpenShift && isRequestPeriodLimitsEnabled) {
                        isValidRequestLimit = adminSetting && Number.isInteger(requestPeriodLimitInDays);
                    }

                    if (adminSetting && adminSetting.requestSubtype === RequestSubtypes.signUp) {
                        isOpenShiftSignUp = true;
                    }
                }

                isInvalid = isInvalid || name.trim() === '' || hyperfindSettings?.length === 0 || hyperfindSettings?.find(config => config.hyperfindId === undefined || config.adminSettingsId === undefined)
                    || (!coverPeriodSelected.forever && coverPeriodSelected.label.trim() === '')
                    || (!requestPeriodSelected.forever && requestPeriodSelected.label.trim() === '')
                    || workrules.excluded.length === 0
                    || requestLocations.length === 0
                    || (isOpenShiftSignUp && !isAllOpenShiftEnabled && selectedOpenShifts.length === 0)
                    || !isValidRequestLimit
                    || hasInvalidHyperfinds

                break;
            case RequestTypes.voluntaryTimeOff:
                const adminSetting = settingList.find(setting => hyperfindSettings[0]?.adminSettingsId === setting.id);
                const isVtoSignUpInvalid = adminSetting && adminSetting.requestSubtype === RequestSubtypes.signUp
                    && (selectedHyperfindRatios.length === 0 || !!selectedHyperfindRatios.find(x => !x.label && !x.value));
               
                isInvalid = isInvalid 
                    || (adminSetting && adminSetting.requestSubtype === RequestSubtypes.signUp && hyperfindRatioErrors)
                    || name.trim() === '' 
                    || hyperfindSettings.find(config => config.hyperfindId === undefined || config.adminSettingsId === undefined) 
                    || coverPeriodSelected.label.trim() === '' 
                    || hyperfindSettings.length === 0 
                    || requestPeriodSelected.singleLabel.trim() === '' && requestPeriodSelected.label.trim() === '' 
                    || vtoTypes.find(type => type.checked) === undefined 
                    || (typeof vtoTypes.find(type => type.checked) !== 'undefined' && vtoTypes.find(type => type.checked).value === 2 && selectedTimePeriodRatioOption === null) 
                    || isVtoSignUpInvalid 
                    || !maximumVtoCount 
                    || hasInvalidHyperfinds
                break;
            default:
                return true;
        }

        const isCoverRangeInvalid = !coverPeriodSelected.forever
            && coverPeriodSelected.label.trim() !== ''
            && moment(coverPeriodSelected.startDate).isSameOrAfter(coverPeriodSelected.endDate);

        const isSubmitable = !isInvalid && !isCoverRangeInvalid && this.isDirtyForm();

        this.setState({ isSubmitable });
    }

    handleApplyDateRangePicker = (picker, target) => {
        const label = formatDateRange(picker.startDate, picker.endDate, target === "cover" ? getAsLongDateTime : getAsLongDate);
        const formattedStartDate = getAsLongDate(picker.startDate.toDate());
        let foundSelectedPeriod = {
            startDate: picker.startDate,
            endDate: picker.endDate,
            label: label,
            singleLabel: formattedStartDate,
            forever: false,
        }

        if (target === 'request') {
            const ymdStartDate = formatAs(picker.startDate.toDate(), DateFnsFormats.YMD);
            getParsedLocations(ymdStartDate)
                .then(tree => {
                    this.setState({
                        locationEffectiveDate: formattedStartDate,
                        locationNodes: tree
                    })
                })
        }

        this.setState({
            [target + 'PeriodSelected']: foundSelectedPeriod,
        }, () => this.submitableForm())
    }

    handleForever = (event, target) => {
        const { todayDateYMD, todayDateUserFormat } = this.state;
        const currentChecked = event.target.checked

        if (currentChecked) {
            getParsedLocations(todayDateYMD)
                .then(tree => {
                    this.setState({
                        locationEffectiveDate: todayDateUserFormat,
                        locationNodes: tree
                    })
                });
        }


        this.setState(prevState => ({
            [target + 'PeriodSelected']: {
                ...prevState[target + 'PeriodSelected'],
                label: '',
                forever: currentChecked,
            },
            locationEffectiveDate: currentChecked ? todayDateUserFormat : null,
        }), () => this.submitableForm())
    }

    /**
     * @param {string|null} label rendered as a notched label on the box when `outlinedLabel` is true
     * @param {string|null} description rendered above the box; pass null when the caller lays out its own description
     * @param {boolean} outlinedLabel false when the caller renders the label itself (see the periods grid)
     */
    drpCreator = (target, stateTarget, label, description, anyTimeEnabled = true, singleDayToggle, timePickerEnabled = false, outlinedLabel = true) => {
        const { t } = this.props
        const isInvalidRange = stateTarget === 'cover'
            && !target.forever
            && target.label.trim() !== ''
            && moment(target.startDate).isSameOrAfter(target.endDate);
        return (
            <div>
                <ReactDatePicker
                    outlinedLabel={outlinedLabel}
                    label={label}
                    description={description}
                    date={target.label}
                    startDate={target.startDate}
                    endDate={target.endDate}
                    onApply={(event, picker) => {
                        this.handleApplyDateRangePicker(picker, stateTarget)
                    }}
                    onHide={(event, picker) => {
                        this.handleApplyDateRangePicker(picker, stateTarget)
                    }}
                    drops={"up"}
                    opens={"left"}
                    onForever={anyTimeEnabled ? (event) => {
                        this.handleForever(event, stateTarget)
                    } : undefined}
                    forever={target.forever}
                    foreverLabel={t('form.forever')}
                    disabled={target.forever}
                    isEmpty={(!target.forever && !target.label)}
                    singleDayToggle={singleDayToggle}
                    timePicker={timePickerEnabled}
                    minDate={applyUkgUserTimeZoneTransformation(new Date())}
                    errorMessage={isInvalidRange ? t('form.invalidPeriodRange') : undefined}
                />
            </div>

        )
    }

    toggleBlockDays = (value) => {
        const { isBlockDays, requestPeriodSelected, vtoTypes } = this.state;
        let startDateEndOfDay = requestPeriodSelected.startDate.clone().endOf('day')
        let newVtoTypes = vtoTypes.map(type => {
            if (parseInt(value) === type.value) {
                return {
                    ...type,
                    checked: true
                }
            }
            return {
                ...type,
                checked: false
            }
        })
        this.setState({
            isBlockDays: parseInt(value) === 1,
            vtoTypes: newVtoTypes,
            requestPeriodSelected: {
                startDate: requestPeriodSelected.startDate,
                endDate: isBlockDays ? requestPeriodSelected.endDate : startDateEndOfDay,
                label: isBlockDays
                    ? formatDateRange(requestPeriodSelected.startDate, requestPeriodSelected.endDate, getAsLongDate)
                    : formatDateRange(requestPeriodSelected.startDate, requestPeriodSelected.startDate, getAsLongDate),
                singleLabel: formatAs(requestPeriodSelected.startDate, DateFnsFormats.YMD),
            },
            multiSingleDates: [],
        }, () => this.submitableForm())
    }

    onCheckAllOpenShift = ({ target: { checked: isChecked } }) => this.setState({
        isAllOpenShiftEnabled: isChecked,
        ...(isChecked ? { selectedOpenShifts: [] } : {}),
    }, () => this.submitableForm());

    /** @param {boolean} isRequestPeriodLimitsEnabled */
    onChangeToggleRequestPeriodLimits = (isRequestPeriodLimitsEnabled) => this.setState({ isRequestPeriodLimitsEnabled }, this.submitableForm);

    typeSpecificOptions = (stepIndex) => {
        const {
            requestType, coverPeriodSelected, requestPeriodSelected, hyperfindSettings, vtoTypes, timePeriodRatioOptions, selectedTimePeriodRatioOption, locationEffectiveDate, locationNodes, requestLocations,
            openShiftOptions, isAllOpenShiftEnabled, selectedOpenShifts, requestPeriodLimitInDays, maximumVtoCount,
        } = this.state;
        const { t, settingList, action } = this.props;
        const classes = MSF_CLASSES;

        const vtoTypeRadios = () => {
            if (hyperfindSettings.length > 0) {
                let adminSetting = settingList.find(setting => hyperfindSettings[0].adminSettingsId === setting.id)
                if (adminSetting) {
                    let selected = vtoTypes.find(type => type.checked).value
                    return <RadioGroup aria-label="vtoTypes" name="vtoTypes" value={selected} onChange={(e) => this.toggleBlockDays(e.target.value)} style={{ display: "inline" }}>
                        {
                            vtoTypes.filter(type => adminSetting.voluntaryTimeOffTypes.includes(type.value)).map(type => {
                                return <FormControlLabel key={type.value} value={type.value}
                                    control={<Radio color="primary" size="small" />}
                                    label={<Typography style={{ fontSize: '12px' }}>{t(`form.vtoTypes.${type.translation}`)}</Typography>} />
                            })
                        }
                    </RadioGroup>
                }
            }
            return null
        };

        const isShowLimits = this.isShowRequestPeriodLimits();

        const datePickers = () => {
            let datePickersContent;

            switch (requestType.value) {
                case RequestTypes.openShift:
                    let adminSetting = settingList.find(setting => hyperfindSettings[0].adminSettingsId === setting.id)
                    if (adminSetting && adminSetting.requestSubtype === RequestSubtypes.signUp) {
                        datePickersContent = (
                            <>
                                <Grid item xs={6}>
                                    {this.drpCreator(coverPeriodSelected, 'cover', t('form.selectCover'), t('form.selectCoverDescription'), false, null, true)}
                                </Grid>
                                <Grid item xs={6}>
                                    {this.drpCreator(requestPeriodSelected, 'request', t('form.selectRequest'), t('form.selectRequestDescription'), false)}
                                </Grid>
                            </>
                        )
                    } else {
                        datePickersContent = (
                            <>
                                <Grid item xs={6}>
                                    {this.drpCreator(coverPeriodSelected, 'cover', t('form.selectCover'), t('form.selectCoverDescription'), true, null, true)}
                                </Grid>
                                <Grid item xs={6}>
                                    {this.drpCreator(requestPeriodSelected, 'request', t('form.selectRequest'), t('form.selectRequestDescription'))}
                                </Grid>
                                <Grid item xs={12}>
                                    <RequestPeriodLimits
                                        classes={classes}
                                        requestPeriodLimit={requestPeriodLimitInDays}
                                        onChangeToggle={this.onChangeToggleRequestPeriodLimits}
                                        onChange={(limit) => this.setState({ requestPeriodLimitInDays: limit }, this.submitableForm)}
                                    />
                                </Grid>
                            </>
                        )
                    }
                    break
                case RequestTypes.voluntaryTimeOff:
                    const selectedVtoType = vtoTypes.find(type => type.checked);
                    const vtoContent = (requestPeriodPicker, requestPeriodDescription) => {
                        const typeRadios = vtoTypeRadios();

                        return (
                            <Grid item xs={12}>
                                <div className={classes.periodsGrid}>
                                    <Typography className={classes.periodLabel}>{t('form.selectCover')}</Typography>
                                    <Typography className={classes.periodLabel}>{t('form.selectRequest')}</Typography>

                                    {typeRadios && <><div /><div>{typeRadios}</div></>}

                                    <Typography className={classes.periodLabel}>{t('form.selectCoverDescription')}</Typography>
                                    <Typography className={classes.periodLabel}>{requestPeriodDescription}</Typography>

                                    <div className={classes.periodPicker}>
                                        {this.drpCreator(coverPeriodSelected, 'cover', null, null, false, null, true, false)}
                                    </div>
                                    <div className={classes.periodPicker}>{requestPeriodPicker}</div>
                                </div>
                            </Grid>
                        );
                    };

                    if (selectedVtoType) {
                        switch (selectedVtoType.value) {
                            case VoluntaryTimeOffType.SingleDay:
                                if (action === ManagerCreateRequestsActionNames.Create || action === ManagerCreateRequestsActionNames.Duplicate) {
                                    datePickersContent = (
                                        <>
                                            {vtoContent(
                                                <MultiSingleDayPicker
                                                    multiSingleDates={this.state.multiSingleDates}
                                                    setMultiSingleDates={(x) => this.setState({ multiSingleDates: x })}
                                                    onApply={(event, picker) => {
                                                        this.handleApplyDateRangePicker(picker, 'request')
                                                    }}
                                                    drops={"up"}
                                                    isEmpty={(!requestPeriodSelected.singleLabel)}
                                                    startDate={requestPeriodSelected.startDate}
                                                    endDate={requestPeriodSelected.endDate}
                                                    minDate={applyUkgUserTimeZoneTransformation(new Date())}
                                                >
                                                </MultiSingleDayPicker>,
                                                t('form.selectRequestDayDescription'))}
                                        </>)
                                }
                                else {
                                    datePickersContent = (
                                        <>
                                            {vtoContent(
                                                <ReactDatePicker
                                                    autoApply
                                                    date={requestPeriodSelected.singleLabel}
                                                    onApply={(event, picker) => {
                                                        this.handleApplyDateRangePicker(picker, 'request')
                                                    }}
                                                    drops={"up"}
                                                    singleDatePicker
                                                    isEmpty={(!requestPeriodSelected.singleLabel)}
                                                    startDate={requestPeriodSelected.startDate}
                                                    endDate={requestPeriodSelected.endDate}
                                                    minDate={applyUkgUserTimeZoneTransformation(new Date())}
                                                />,
                                                t('form.selectRequestDayDescription')
                                            )}
                                        </>)
                                }
                                break
                            case VoluntaryTimeOffType.BlockOfDays:
                                datePickersContent = (
                                    <>
                                        {vtoContent(
                                            <ReactDatePicker
                                                date={formatDateRange(requestPeriodSelected.startDate, requestPeriodSelected.endDate, getAsLongDate)}
                                                startDate={requestPeriodSelected.startDate}
                                                endDate={requestPeriodSelected.endDate}
                                                onApply={(event, picker) => {
                                                    this.handleApplyDateRangePicker(picker, 'request')
                                                }}
                                                onHide={(event, picker) => {
                                                    this.handleApplyDateRangePicker(picker, 'request')
                                                }}
                                                drops={"up"}
                                                opens={"left"}
                                                forever={requestPeriodSelected.forever}
                                                foreverLabel={t('form.forever')}
                                                disabled={requestPeriodSelected.forever}
                                                isEmpty={(!requestPeriodSelected.forever && !requestPeriodSelected.label)}
                                                minDate={applyUkgUserTimeZoneTransformation(new Date())}
                                            />,
                                            t('form.selectRequestDescription')
                                        )}
                                    </>
                                )
                                break
                            case VoluntaryTimeOffType.TimePeriod:
                                let adminSetting = settingList.find(setting => hyperfindSettings[0].adminSettingsId === setting.id)
                                if (adminSetting) {
                                    datePickersContent = (
                                        <>
                                            {vtoContent(
                                                <ReactDatePicker
                                                    date={formatDateRange(requestPeriodSelected.startDate, requestPeriodSelected.endDate, getAsLongDateTime)}
                                                    onApply={(event, picker) => {
                                                        this.handleApplyDateRangePicker(picker, 'request')
                                                    }}
                                                    drops={"up"}
                                                    isEmpty={(!requestPeriodSelected.label)}
                                                    startDate={requestPeriodSelected.startDate}
                                                    endDate={requestPeriodSelected.endDate}
                                                    timePicker
                                                    maxSpan={{ days: 1 }}
                                                    minDate={applyUkgUserTimeZoneTransformation(new Date())}
                                                />,
                                                t('form.selectRequestDayDescription')
                                            )}
                                            <Grid item xs={12}>
                                                <Card className={classes.cards} style={{ marginTop: 0 }}>
                                                    <CardHeader className={classes.cardHeader} style={{ fontSize: '0.75rem' }} disableTypography title={<Typography color="textSecondary" gutterBottom style={{ fontSize: '0.75rem' }}>{t('form.timePeriodOptionsTitle')}</Typography>} />
                                                    <CardContent>
                                                        <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                {generateInputs(t('form.coverageOption'), t('form.selectCoverageOption'), selectedTimePeriodRatioOption, timePeriodRatioOptions.filter(option => adminSetting.timePeriodRatioOptions.includes(option.id)), 'selectedTimePeriodRatioOption', false, false, t('form.coverageOptionDescription'), this.handleChange)}
                                                            </Grid>
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        </>
                                    )
                                }
                                break
                            default:
                                datePickersContent = null
                        }
                    }
                    break
                default:
                    datePickersContent = (
                        <>
                            <Grid item xs={6}>
                                {this.drpCreator(coverPeriodSelected, 'cover', t('form.selectCover'), t('form.selectCoverDescription'), true, null, true)}
                            </Grid>
                            <Grid item xs={6}>
                                {this.drpCreator(requestPeriodSelected, 'request', t('form.selectRequest'), t('form.selectRequestDescription'))}
                            </Grid>
                            <Grid item xs={12}>
                                {
                                    isShowLimits && (
                                        <RequestPeriodLimits
                                            classes={classes}
                                            requestPeriodLimit={requestPeriodLimitInDays}
                                            onChangeToggle={this.onChangeToggleRequestPeriodLimits}
                                            onChange={(limit) => this.setState({ requestPeriodLimitInDays: limit }, this.submitableForm)}
                                        />
                                    )
                                }
                            </Grid>
                        </>
                    )
            }
            return datePickersContent
        }

        const onConfirmLocations = (values) => {
            this.setState(
                { requestLocations: values },
                () => this.submitableForm()
            );
        };

        /** @param {number[]} selectedOpenShifts */
        const confirmSelectedOpenShifts = (selectedOpenShifts) => this.setState(
            { selectedOpenShifts },
            () => this.submitableForm(),
        );

        const osPickerKey = generateReactKey('os-picker');


        switch (requestType.value) {
            case RequestTypes.toCover:
            case RequestTypes.shiftSwap:
                return (
                    <>
                        <Card className={classes.cards}>
                            <CardHeader
                                className={classes.cardHeader}
                                titleTypographyProps={{ color: 'textSecondary', gutterBottom: true }}
                                avatar={<Avatar aria-label={t('form.step', { number: 4 })} className={classes.avatar}>{stepIndex++}</Avatar>}
                                title={t('form.periodsTitle')}
                            />
                            <CardContent>
                                <Grid
                                    container
                                    spacing={3}
                                >
                                    {datePickers()}
                                </Grid>
                            </CardContent>
                        </Card>
                    </>
                );
            case RequestTypes.openShift:
                let isOpenShiftSignUp = false;
                if (hyperfindSettings.length > 0 && typeof hyperfindSettings[0].adminSettingsId !== 'undefined') {
                    const adminSetting = settingList.find(setting => hyperfindSettings[0].adminSettingsId === setting.id);

                    if (adminSetting && adminSetting.requestSubtype === RequestSubtypes.signUp) {
                        isOpenShiftSignUp = true;
                    }

                    return (
                        <>
                            <Card className={classes.cards}>
                                <CardHeader className={classes.cardHeader} titleTypographyProps={{ color: 'textSecondary', gutterBottom: true }} avatar={<Avatar aria-label={t('form.step', { number: 4 })} className={classes.avatar}>{stepIndex++}</Avatar>} title={t('form.periodsTitle')} />
                                <CardContent>
                                    <Grid container spacing={3}>
                                        {datePickers()}
                                    </Grid>
                                </CardContent>
                            </Card>
                            <Card className={classes.cards}>
                                <CardHeader className={classes.cardHeader} titleTypographyProps={{ color: 'textSecondary', gutterBottom: true }} avatar={<Avatar aria-label={t('form.step', { number: 5 })} className={classes.avatar}>{stepIndex++}</Avatar>} title={t('form.workrules')} />
                                <CardContent>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Dualbox
                                                data={this.state.workrules.excluded}
                                                subHeader={t('form.chooseWorkrules')}
                                                target={'workrules'}
                                                rightBoxText={t('form.selected')}
                                                leftBoxText={t('form.available')}
                                                moveAllToRightText={t('form.selectAll')}
                                                moveAllToLeftText={t('form.deselectAll')}
                                                dataSelected={this.state.workrules.included}
                                                handleChangeDualBox={handleChangeDualBox(this)}
                                                moveAll={moveAll(this)}
                                                handleUpdates={this.submitableForm} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <LocationsPicker
                                                period={locationEffectiveDate}
                                                locationNodes={locationNodes}
                                                selectedNodeIds={requestLocations}
                                                onConfirm={onConfirmLocations}
                                            />
                                        </Grid>
                                        {
                                            isOpenShiftSignUp && (
                                                <Grid item xs={12} className="os-selection">
                                                    <FormControlLabel
                                                        control={(
                                                            <Checkbox
                                                                checked={isAllOpenShiftEnabled}
                                                                onClick={this.onCheckAllOpenShift}
                                                            />
                                                        )}
                                                        label={t("form.allOpenShifts")}
                                                    />
                                                    <Divider className="os-picker-divider-text">{t('form.or')}</Divider>
                                                    <OpenShiftPicker
                                                        key={osPickerKey}
                                                        isDisabled={isAllOpenShiftEnabled || !this.isOpenShiftOptionsEnabled()}
                                                        openShiftOptions={openShiftOptions}
                                                        period={locationEffectiveDate}
                                                        onConfirm={confirmSelectedOpenShifts}
                                                        selectedOpenShiftsOptions={selectedOpenShifts}
                                                    />
                                                </Grid>
                                            )
                                        }
                                    </Grid>
                                </CardContent>
                            </Card>
                        </>
                    );
                }

                return null;
            case RequestTypes.voluntaryTimeOff:
                
                if (hyperfindSettings.length > 0 && typeof hyperfindSettings[0].adminSettingsId !== 'undefined') {
                    const adminSetting = settingList.find(x => x.id === hyperfindSettings[0].adminSettingsId);
                    let ratioSection;
                    if (adminSetting && adminSetting.requestSubtype === RequestSubtypes.fill) {
                        ratioSection = (
                            <>
                                <CardHeader className={classes.cardHeader} titleTypographyProps={{ color: 'textSecondary', gutterBottom: true }} avatar={<Avatar aria-label={t('form.step', { number: 5 })} className={classes.avatar}>{stepIndex++}</Avatar>} title={t('form.fillVtoStepHeader')} />
                                <CardContent>
                                    <NumberInput
                                        handleChangeInput={(value) => {
                                            this.setState(
                                                { maximumVtoCount: value },
                                                () => this.submitableForm()
                                            );
                                        }}
                                        label={t('form.maxFillVtoAllowed')}
                                        min={1}
                                        max={10000}
                                        step={1}
                                        precision={0}
                                        value={maximumVtoCount}
                                        defaultValue={1}
                                    />
                                </CardContent>
                            </>);
                    }
                    else {
                        ratioSection = (
                            <>
                                <CardHeader className={classes.cardHeader} titleTypographyProps={{ color: 'textSecondary', gutterBottom: true }} avatar={<Avatar aria-label={t('form.step', { number: 5 })} className={classes.avatar}>{stepIndex++}</Avatar>} title={t('form.hyperfindRatio')} />
                                <CardContent>
                                    <HyperfindRatio
                                        hyperFindList={this.state.hyperFindList}
                                        selectedHyperfindRatios={this.state.selectedHyperfindRatios}
                                        setSelectedHyperfindRatios={(value) => this.setState({ selectedHyperfindRatios: value })}
                                        onChangeCallback={this.submitableForm}
                                        setErrors={(value) => this.setState({ hyperfindRatioErrors: value }, this.submitableForm)}
                                        setMaximumVtoCount={(value) => this.setState({maximumVtoCount : value})}
                                    />
                                </CardContent>
                            </>
                        );
                    }
                
                    return (
                        <>
                            <Card className={classes.cards}>
                                {ratioSection}
                            </Card>
                            <Card className={classes.cards}>
                                <CardHeader className={classes.cardHeader} titleTypographyProps={{ color: 'textSecondary', gutterBottom: true }} avatar={<Avatar aria-label={t('form.step', { number: 4 })} className={classes.avatar}>{stepIndex++}</Avatar>} title={t('form.periodsTitle')} />
                                <CardContent>
                                    <Grid container spacing={3}>
                                        {datePickers()}
                                    </Grid>
                                </CardContent>
                            </Card>

                            <Card className={classes.cards}>
                                <CardHeader className={classes.cardHeader} titleTypographyProps={{ color: 'textSecondary', gutterBottom: true }} avatar={<Avatar aria-label={t('form.step', { number: 6 })} className={classes.avatar}>{stepIndex++}</Avatar>} title={t('form.locationsAndJobs')} />
                                <CardContent>
                                    <Grid item xs={12}>
                                        <Typography className='vto-request-location-description'>{t('form.locationsAndJobsDescription')}</Typography>
                                        <div className='vto-request-location-picker'>
                                            <LocationsPicker
                                                period={locationEffectiveDate}
                                                locationNodes={locationNodes}
                                                selectedNodeIds={requestLocations}
                                                onConfirm={onConfirmLocations}
                                                isOptional
                                            />
                                            <Tooltip
                                                title={t("form.locationsAndJobsTooltip")}
                                                arrow
                                            >
                                                <HelpIcon
                                                    className='vto-request-location-help-icon'
                                                    fontSize="small"
                                                />
                                            </Tooltip>
                                        </div>
                                        
                                    </Grid>
                                </CardContent>
                            </Card>
                        </>
                    );
                }

                return null;
            default:
                return null;
        }
    }

    onSelectAdminSetting = (configs) => {
        const { requestType } = this.state;
        const { settingList } = this.props;
        let dataToReset = () => { };

        configs.forEach(conf => {
            const adminSetting = settingList.find(x => x.id === conf.adminSettingsId);
            conf.enablePartialShifts = conf.enablePartialShifts && adminSetting && adminSetting.enablePartialShifts;
        });


        if (requestType.value === RequestTypes.openShift) {
            const adminSetting = settingList.find(x => x.id === configs[0]?.adminSettingsId);
            if (adminSetting && adminSetting.requestSubtype === RequestSubtypes.signUp) {//OS Sign Up does not have Forever ticker
                dataToReset = (state) => ({
                    coverPeriodSelected: {
                        ...state.coverPeriodSelected,
                        forever: false,
                    },
                    requestPeriodSelected: {
                        ...state.requestPeriodSelected,
                        forever: false,
                    },
                });
            }
        }
        else if (requestType.value === RequestTypes.voluntaryTimeOff) {
            const adminSetting = settingList.find(x => x.id === configs[0]?.adminSettingsId);
            if (adminSetting) {
                const typeToCheck = VTO_TYPES.find(x => adminSetting.voluntaryTimeOffTypes.includes(x.value));
                if (typeToCheck) {
                    let newVtoTypes = VTO_TYPES.map(x => ({
                        ...x,
                        checked: typeToCheck === x,
                    }));
                    dataToReset = (state) => ({
                        vtoTypes: newVtoTypes,
                        selectedTimePeriodRatioOption: null
                    });
                }
            }
        }

        this.setState((state) => {
            return {
                hyperfindSettings: configs,
                ...dataToReset(state),
            }

        }, () => { this.submitableForm() })
    }

    /**
     * Checks for all required fields in the form to enable the `SelectionOpenShiftOptions` feature
     * @returns {boolean} `True` if enabled
     */
    isOpenShiftOptionsEnabled = () => {
        const {
            requestLocations,
            requestPeriodSelected: { startDate: requestStartDate, endDate: requestEndDate },
            requestType,
        } = this.state;

        const isOpenShift = requestType.value === RequestTypes.openShift;

        return (
            isOpenShift &&
            requestLocations.length &&
            !!requestStartDate &&
            !!requestEndDate
        );
    };

    fetchSelectOpenShiftData = () => {
        const {
            requestLocations,
            requestPeriodSelected: { startDate: requestStartDate, endDate: requestEndDate, },
            workrules: { excluded: selectedWorkRules },
            selectedOpenShifts,
        } = this.state;

        const workRuleIds = selectedWorkRules.map(({ workRuleId }) => workRuleId);

        /** @type {OpenShiftOptionsParams} */
        const paramsOpenShiftOptions = {
            startDate: requestStartDate.format(MomentFormats.YMD),
            endDate: requestEndDate.format(MomentFormats.YMD),
            locationIds: requestLocations,
            workRuleIds,
        };

        getOpenShiftOptions(paramsOpenShiftOptions).then(
            ({ openShiftOptions: { data: openShiftOptions } }) => {
                const updatedSelectedOpenShifts = selectedOpenShifts.filter(x => openShiftOptions.some(y => y.id === x));
                this.setState({ openShiftOptions, selectedOpenShifts: updatedSelectedOpenShifts })
            },
        );
    };

    render() {
        const { t, cancel, hyperFindList, settingList, action, managerList, settingSelected } = this.props;
        const classes = MSF_CLASSES;
        const { name, description, details, requestType, isSubmitable, isFullyEditable, hyperfindSettings } = this.state;
        const settingRequestTypes = _.uniqBy(settingList, (x) => x.actionType).map((x) => x.actionType);
        const selectableRequestTypes = requestTypeList.filter((x) => settingRequestTypes.includes(x.value));

        const isOpenShiftOrVTO = [RequestTypes.openShift, RequestTypes.voluntaryTimeOff].includes(requestType.value);
        let stepIndex = 1;
        if (document.getElementById('sidebar'))
            document.getElementById('sidebar').parentElement.classList.remove(classes.NOOVERFLOW);

        const containerClass = [classes.formContainer];
        if (action === ManagerCreateRequestsActionNames.View) {
            containerClass.push(classes.formContainerReadOnly)
        }

        return (
            <>
                <div className={containerClass.join(' ')}>
                    <Card className={classes.cards}>
                        <CardHeader className={classes.cardHeader} titleTypographyProps={{ color: 'textSecondary' }} avatar={<Avatar aria-label={t('form.step', { number: 1 })} className={classes.avatar}>{stepIndex++}</Avatar>} title={t('form.information')} />
                        <CardContent>
                            <SettingInformationStep
                                classes={classes}
                                name={name}
                                description={description}
                                details={details}
                                handleChangeTextfield={this.handleChangeTextfield}
                                managerList={managerList}
                                action={action}
                                settingSelected={settingSelected}
                                usedManagerSettingNames={managerList.filter(x => x.aggregateRootId !== settingSelected.aggregateRootId).map(x => x.name)}
                                setErrors={(value) => this.setState({ step1Errors: value }, this.submitableForm)}
                            />
                        </CardContent>
                    </Card>

                    <Card className={classes.cards}>
                        <CardHeader className={classes.cardHeader} titleTypographyProps={{ color: 'textSecondary', gutterBottom: true }} avatar={<Avatar aria-label={t('form.step', { number: 2 })} className={classes.avatar}>{stepIndex++}</Avatar>} title={t('form.bidSetting')} />
                        <CardContent>
                            {generateInputs(
                                t('settings.requestType'),
                                t('form.requestTypeSelect'),
                                requestType,
                                selectableRequestTypes,
                                'requestType',
                                (action === ManagerCreateRequestsActionNames.Edit && !isFullyEditable),
                                !requestType && !requestType.value ? true : false,
                                t('settings.requestTypeNote'),
                                (_, value) => this.handleChangeRequestType(value))}
                        </CardContent>
                    </Card>
                    {requestType ? <Card className={classes.cards}>
                        <CardHeader className={classes.cardHeader} titleTypographyProps={{ color: 'textSecondary', gutterBottom: true }} avatar={<Avatar aria-label={t('form.step', { number: 3 })} className={classes.avatar}>{stepIndex++}</Avatar>} title={t('settings.peopleConfigurationSets')} />
                        <CardContent>
                            <HyperfindConfigs
                                settingSelected={settingSelected}
                                hyperFindList={hyperFindList}
                                configs={hyperfindSettings}
                                adminSettingList={settingList.filter(x => x.actionType === requestType.value)}
                                handleInputchange={this.onSelectAdminSetting}
                                maxConfigs={isOpenShiftOrVTO ? 1 : 999}
                                isFullyEditable={isFullyEditable}
                                hideOnMax={isOpenShiftOrVTO}
                                setErrors={(value) => this.setState({ hyperfindConfigErrors: value })}
                            />
                        </CardContent>
                    </Card> : null}
                    {this.typeSpecificOptions(stepIndex)}
                </div>
                {action === ManagerCreateRequestsActionNames.View
                    ? (
                        <div style={{ display: 'flex', padding: '14px', justifyContent: 'flex-end' }}>
                            <CustomButton onClick={cancel} variant="contained" color="secondary" size="medium">
                                {t('form.close')}
                            </CustomButton>
                        </div>
                    )
                    : (
                        <ActionButtons
                            cancel={cancel}
                            submit={this.submitForm}
                            disabledSubmit={!isSubmitable}
                            submitText={t('form.save')}
                            cancelText={t('form.cancel')}
                        />
                    )
                }
            </>
        );
    }
}

export default withTranslation('employmentBillboard')(Form);
